/**
 * DEV-ONLY: Control panel for design overlay. Used by DesignOverlayGlobal.
 */
import React from "react";

export default function DesignOverlayPanel({
  visible,
  onVisibleChange,
  opacity,
  onOpacityChange,
  offsetX,
  onOffsetXChange,
  offsetY,
  onOffsetYChange,
  mode,
  onModeChange,
  onReset,
  widthPx,
  heightPx,
  onWidthChange,
  onHeightChange,
  lockAspectRatio,
  onLockAspectRatioChange,
  naturalWidth,
  naturalHeight,
}) {
  return (
    <div className="design-overlay__panel" aria-label="Design overlay controls">
      <label className="design-overlay__row">
        <input
          type="checkbox"
          checked={visible}
          onChange={(e) => onVisibleChange(e.target.checked)}
        />
        <span>Show</span>
      </label>
      <label className="design-overlay__row">
        <span>Opacity</span>
        <input
          type="range"
          min="0"
          max="1"
          step="0.05"
          value={opacity}
          onChange={(e) => onOpacityChange(Number(e.target.value))}
        />
        <span className="design-overlay__value">{Math.round(opacity * 100)}%</span>
      </label>
      <label className="design-overlay__row">
        <span>X</span>
        <input
          type="number"
          value={offsetX}
          onChange={(e) => onOffsetXChange(Number(e.target.value) || 0)}
          className="design-overlay__input-num"
        />
      </label>
      <label className="design-overlay__row">
        <span>Y</span>
        <input
          type="number"
          value={offsetY}
          onChange={(e) => onOffsetYChange(Number(e.target.value) || 0)}
          className="design-overlay__input-num"
        />
      </label>
      <label className="design-overlay__row">
        <span>Mode</span>
        <select
          value={mode}
          onChange={(e) => onModeChange(e.target.value)}
          className="design-overlay__select"
        >
          <option value="normal">Normal</option>
          <option value="difference">Difference</option>
        </select>
      </label>

      {(onWidthChange != null || onHeightChange != null) && (
        <>
          <div className="design-overlay__panel-label">Size</div>
          <label className="design-overlay__row">
            <span>Width</span>
            <input
              type="number"
              value={widthPx ?? ""}
              onChange={(e) => onWidthChange(Number(e.target.value) || 0)}
              className="design-overlay__input-num"
              placeholder={naturalWidth != null ? String(naturalWidth) : "—"}
            />
            <span className="design-overlay__unit">px</span>
          </label>
          <label className="design-overlay__row">
            <span>Height</span>
            <input
              type="number"
              value={heightPx ?? ""}
              onChange={(e) => onHeightChange(Number(e.target.value) || 0)}
              className="design-overlay__input-num"
              placeholder={naturalHeight != null ? String(naturalHeight) : "—"}
            />
            <span className="design-overlay__unit">px</span>
          </label>
          <label className="design-overlay__row">
            <input
              type="checkbox"
              checked={lockAspectRatio}
              onChange={(e) => onLockAspectRatioChange?.(e.target.checked)}
            />
            <span>Lock aspect ratio</span>
          </label>
        </>
      )}

      <button type="button" className="design-overlay__reset" onClick={onReset}>
        Reset
      </button>
    </div>
  );
}
